import { useState } from 'react';

// material-ui
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import { CircularProgress, Grid, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

// project imports
import { getFormattedDate } from 'helpers/dates';
import { useSelector } from 'store';
import MainCard from 'ui-component/cards/MainCard';
import SubCard from 'ui-component/cards/SubCard';
import { SEARCH_TYPE } from '../constant';
import useStyles from '../styles';
import DateTypeFilter from './dateTypeFilter';

const MemberSearches = () => {
    const classes = useStyles();
    const theme = useTheme();

    const [isLoading, setIsLoading] = useState(true);
    const memberPriorityData = useSelector((state) => state?.memberPriority);
    const { memberSearches = {} } = memberPriorityData || {};
    const { searches = {} } = memberSearches || {};
    const { flight_searches: flightSearches = {}, hotel_searches: hotelSearches = {} } = searches || {};
    const { count: flightSearchCount = '', last_created_at: lastFlightSearchDate = '' } = flightSearches || {};
    const { count: hotelSearchCount = '', last_created_at: lastHotelSearchDate = '' } = hotelSearches || {};

    const handleLoadingState = (loading = false) => {
        setIsLoading(loading);
    };

    return (
        <>
            <Grid container item spacing={3} direction="column" xs={12}>
                <Grid container item xs={12} alignItems="center" justifyContent="space-between">
                    <Grid xs={2} container item alignItems="center" spacing={0.5}>
                        <Grid item>
                            <FilterAltIcon sx={{ color: theme.palette.primary.dark }} />
                        </Grid>
                        <Grid item>
                            <Typography variant="h4" sx={{ fontWeight: 500 }}>
                                Filters
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid item xs={10}>
                        <DateTypeFilter type={SEARCH_TYPE} isLoading={isLoading} handleLoadingState={handleLoadingState} />
                    </Grid>
                </Grid>
                {isLoading ? (
                    <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
                        <CircularProgress />
                    </Grid>
                ) : (
                    <Grid container item xs={12} spacing={3}>
                        <Grid item xs={12}>
                            <MainCard>
                                <Grid container spacing={2}>
                                    <Grid item>
                                        <Typography variant="h3" sx={{ fontWeight: 500 }}>
                                            Flights
                                        </Typography>
                                    </Grid>
                                    <Grid container item spacing={2} xs={12}>
                                        <Grid item xs={6}>
                                            <SubCard className={classes.searchGrid}>
                                                <Grid item container spacing={0.6} xs={12}>
                                                    <Grid item xs={12}>
                                                        <Typography variant="h3" sx={{ fontWeight: 500, color: theme.palette.grey[900] }}>
                                                            {flightSearchCount || '0'}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <Typography
                                                            variant="subtitle1"
                                                            sx={{ fontWeight: 400, color: theme.palette.text.secondary }}
                                                        >
                                                            Searches
                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                            </SubCard>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <SubCard className={classes.searchGrid}>
                                                <Grid item container spacing={0.6} xs={12}>
                                                    <Grid item xs={12}>
                                                        <Typography variant="h3" sx={{ fontWeight: 500, color: theme.palette.grey[900] }}>
                                                            {getFormattedDate(lastFlightSearchDate) || '-'}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <Typography
                                                            variant="subtitle1"
                                                            sx={{ fontWeight: 400, color: theme.palette.text.secondary }}
                                                        >
                                                            Last Search Date
                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                            </SubCard>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </MainCard>
                        </Grid>
                        <Grid item xs={12}>
                            <MainCard>
                                <Grid container spacing={2}>
                                    <Grid item>
                                        <Typography variant="h3" sx={{ fontWeight: 500 }}>
                                            Hotels
                                        </Typography>
                                    </Grid>
                                    <Grid container item spacing={2} xs={12}>
                                        <Grid item xs={6}>
                                            <SubCard className={classes.searchGrid}>
                                                <Grid item container spacing={0.6} xs={12}>
                                                    <Grid item xs={12}>
                                                        <Typography variant="h3" sx={{ fontWeight: 500, color: theme.palette.grey[900] }}>
                                                            {hotelSearchCount || '0'}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <Typography
                                                            variant="subtitle1"
                                                            sx={{ fontWeight: 400, color: theme.palette.text.secondary }}
                                                        >
                                                            Searches
                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                            </SubCard>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <SubCard className={classes.searchGrid}>
                                                <Grid item container spacing={0.6} xs={12}>
                                                    <Grid item xs={12}>
                                                        <Typography variant="h3" sx={{ fontWeight: 500, color: theme.palette.grey[900] }}>
                                                            {getFormattedDate(lastHotelSearchDate) || '-'}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <Typography
                                                            variant="subtitle1"
                                                            sx={{ fontWeight: 400, color: theme.palette.text.secondary }}
                                                        >
                                                            Last Search Date
                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                            </SubCard>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </MainCard>
                        </Grid>
                    </Grid>
                )}
            </Grid>
        </>
    );
};

export default MemberSearches;
